'use es6';

import getIn from 'transmute/getIn';
export const getUserId = getIn(['user', 'user_id']);
export const getUserEmail = getIn(['user', 'email']);